import { PageContainerNewLayout } from "@disasterscience/scaffoldy";
import * as Sentry from "@sentry/browser";
import { FallbackProps } from "react-error-boundary";
import { FriendlyError } from "../views/errors/FriendlyError";

export const ReactFallbackError = (props: FallbackProps) => {
    Sentry.captureException(props.error);

    return (
        <>
            <PageContainerNewLayout>
                <FriendlyError errorName={props.error.name} errorStack={props.error.stack} />
            </PageContainerNewLayout>
        </>
    );
};
